module.exports = __webpack_public_path__ + "img/ad1.8b8a3d95.png";